import { createContext, useContext } from 'react';

interface PageTopbarAdornmentContextValue {
  container: HTMLElement | null;
  setContainer: (node: HTMLElement | null) => void;
}

export const PageTopbarAdornmentContext = createContext<PageTopbarAdornmentContextValue>({
  container: null,
  setContainer: () => {},
});

export function usePageTopbarAdornmentContext(): PageTopbarAdornmentContextValue {
  return useContext(PageTopbarAdornmentContext);
}
